module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeFork.451b4b09.png";